import { useCallback, useState } from "react";
import {
  paginationToQueryParams,
  sortToQueryParams,
} from "@/components/BaseTableV3/table-helpers";
import { functionalUpdate } from "@tanstack/react-table";
import { DEFAULT_PAGE_SIZE } from "constants/Constants";

const defaultQueryParams = {
  search: "",
  sort_by: null,
  sort_dir: null,
  page: 1,
  per_page: DEFAULT_PAGE_SIZE,
};

export function useModalTable({ columns = [] }) {
  const [columnOrder, setColumnOrder] = useState(columns.map(col => col.id));
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: DEFAULT_PAGE_SIZE,
  });
  const [sorting, setSorting] = useState([]);
  const [queryParams, setQueryParams] = useState(defaultQueryParams);

  const handleSearchChange = useCallback(
    (search = "") => {
      setQueryParams(prev => ({ ...prev, search: search ?? "" }));
    },
    [setQueryParams]
  );

  const handleSortChange = useCallback(
    async updater => {
      const nextSort = functionalUpdate(updater, sorting);
      setSorting(nextSort);
      const sortQueryParams = sortToQueryParams(nextSort);
      setQueryParams(prev => ({ ...prev, ...sortQueryParams }));
    },
    [setQueryParams, setSorting, sorting]
  );

  const handlePaginationChange = useCallback(
    async updater => {
      const nextPagination = functionalUpdate(updater, pagination);
      setPagination(nextPagination);
      const parsedQueryParams = paginationToQueryParams(nextPagination);
      setQueryParams(prev => ({ ...prev, ...parsedQueryParams }));
    },
    [setQueryParams, setPagination, pagination]
  );

  return {
    columnOrder,
    pagination,
    sorting,
    queryParams,
    setColumnOrder,
    handleSearchChange,
    handleSortChange,
    handlePaginationChange,
  };
}
